import React from "react";

const HeroSection = ({
  heading,
  content,
  image,
  buttonLabel = "Schedule Demo",
  onButtonClick,
}) => {
  return (
    <div className="relative bg-[#F0F3Fc] overflow-hidden">
      {/* Background Shape - Desktop Only */}
      <img
        src="images/Vector_3.webp"
        alt="Background Shape"
        loading="lazy"
        decoding="async"
        className="absolute pointer-events-none z-0 hidden lg:block
          top-[250px] left-0 right-0 m-0 opacity-40 rounded-[1px]"
      />

      <section className="relative z-10 py-12 sm:py-16 lg:pb-32 px-4 sm:px-8 lg:px-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* Text Section */}
          <div className="w-full lg:w-1/2 text-left relative text-primaryBlue">
            <h1 className="mb-4 font-bold leading-snug sm:leading-tight">
              <span className="block text-[24px] sm:text-[32px] md:text-[48px] leading-[1.2] font-extrabold">
                {heading}
              </span>
            </h1>

            <p className="mb-6 font-normal">
              <span className="block text-[14px] sm:text-[18px] md:text-[24px] leading-[1.5]">
                {content}
              </span>
            </p>

            <div className="relative inline-block">
              {onButtonClick ? (
                <button
                  onClick={onButtonClick}
                  aria-label={buttonLabel}
                  className="bg-primaryBlue hover:bg-blue-800 text-white font-semibold px-5 sm:px-6 py-3 rounded-full transition duration-200 z-20 relative inline-block text-sm sm:text-base cursor-pointer"
                >
                  {buttonLabel}
                </button>
              ) : (
                <a
                  href="https://calendly.com/pranav-cargopro/30min"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  aria-label="Schedule a demo through Calendly"
                  className="bg-primaryBlue hover:bg-blue-800 text-white font-semibold px-5 sm:px-6 py-3 rounded-full transition duration-200 z-20 relative inline-block text-sm sm:text-base"
                >
                  {buttonLabel}
                </a>
              )}

              {/* Arrow - Desktop */}
              <img
                src="/images/Pointer_Arrow.webp"
                alt="Arrow"
                loading="lazy"
                decoding="async"
                width="99"
                height="46"
                className="absolute hidden sm:block
                  w-[120px] h-auto top-1/2 left-full
                  -translate-y-1/2 rotate-[10deg] ml-[10px] opacity-80"
              />

              {/* Arrow - Mobile */}
              <img
                src="images/Pointer_Arrow.webp"
                alt="Arrow Mobile"
                loading="lazy"
                decoding="async"
                width="99"
                height="46"
                className="absolute block sm:hidden
                  w-[80px] h-auto top-[60%] left-full
                  -translate-y-1/2 rotate-[10deg] ml-[6px] opacity-80"
              />
            </div>
          </div>

          {/* Image Section */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
            <img
              src={image}
              alt="CargoPro Hero"
              loading="eager"
              decoding="async"
              fetchpriority="high"
              width="600"
              height="328"
              sizes="(min-width: 1024px) 600px, (min-width: 640px) 384px, 320px"
              className="w-full max-w-xs sm:max-w-md lg:max-w-[600px] h-auto"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
